import { BkRoutes } from 'bkng';

import { id } from './id/id';

export const merchant: BkRoutes = [
    {
        path: "id",
        label: "Merchant by ID",
        children: id,
    },
];
